// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1SCEX","container":"styles_container__11kkM","title":"styles_title__19TNe","wrapper":"styles_wrapper__2iX0d","answer":"styles_answer__dIXSE"};